<mat-toolbar color="primary">
  <span id="flytt-sak-dialog-tittel">
    @if (sak().erPause) {
      {{ "Flytt {navn} til annet møte"|translate: {navn: sak().tittel} }}
    } @else {
      {{ "Flytt sak {nummer} {navn} til annet møte"|translate: {nummer: sak().nummer, navn: sak().tittel} }}
    }
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

@switch (modus()) {
  @case ('skjema') {
    <form [formGroup]="skjema" (ngSubmit)="flytt()">
      <mat-dialog-content>
        <p class="info">
          @if (sak().erPause) {
            {{ 'Flytt {tittel} i {gruppetittel} i {organisasjon} med' | translate: {tittel: sak().tittel, gruppetittel: gruppe().tittel, organisasjon: gruppe().organisasjonsnavn} }}
          } @else {
            {{ 'Flytt sak {nummer} {tittel} i {gruppetittel} i {organisasjon} med' | translate: {nummer: sak().nummer, tittel: sak().tittel, gruppetittel: gruppe().tittel, organisasjon: gruppe().organisasjonsnavn} }}
            <span class="tellere">{{ '{antbeslutninger} beslutninger og {antdokumenter} saksdokumenter' | translate: {antbeslutninger: sak().beslutninger.length, antdokumenter: sak().dokumenter.length} }}</span>
          }
          {{ 'til følgende møte'|translate }}
        </p>

        <fieldset>
          <mat-form-field class="møtevelger">
            <mat-label>{{ "Velg møtet du vil flytte saken til" | translate }}</mat-label>
            <!-- tom placeholder da vi ikke ønsker å bruker velg-moeter sin std placeholder -->
            <velg-moeter [skjemakontroll]="skjema.controls.moete" multiple="false" [velgKunFraEkspandertGruppe]="true"  [ekspandertGruppe]="sak().eiendeGruppeId" placeholder=""/>
          </mat-form-field>
        </fieldset>

        <tips>
          <p>{{ 'Saken blir lagt til som siste sak i det valgte møtet.'| translate }}</p>
        </tips>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <div>
          <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
          <submit-button [arbeidPaagaar]="lagrer()" [skjema]="skjema" spinnerTekst="{{'FLytter...'|translate}}">
            {{ 'Flytt sak'|translate }}
          </submit-button>
        </div>
      </mat-dialog-actions>
    </form>
  }
  @case ('kvittering') {
    <mat-dialog-content class="kvittering" data-testid="flytt-sak-dialog-kvittering">
      <p>
        {{ 'Saken har blitt flyttet til' | translate }}:
      </p>
      <p>
        <a (click)="gaaTilSak()">
          @if (kopiertTilMoete()!.sak.erPause) {
            {{ '{sakstittel} i {tittel} {nummer}, {dato} - {gruppetittel} i {organisasjon}'|translate: {sakstittel: kopiertTilMoete()!.sak.tittel, tittel: kopiertTilMoete()!.moete.tittel, nummer: kopiertTilMoete()!.moete.nummer, dato: kopiertTilMoete()!.moete.dato.start|zoneddatetime, gruppetittel: kopiertTilMoete()!.gruppe.tittel, organisasjon: kopiertTilMoete()!.gruppe.organisasjonsnavn} }}
          } @else {
            {{ 'Sak {saksnummer} i {tittel} {nummer}, {dato} - {gruppetittel} i {organisasjon}'|translate: {saksnummer: kopiertTilMoete()!.sak.nummer, tittel: kopiertTilMoete()!.moete.tittel, nummer: kopiertTilMoete()!.moete.nummer, dato: kopiertTilMoete()!.moete.dato.start|zoneddatetime, gruppetittel: kopiertTilMoete()!.gruppe.tittel, organisasjon: kopiertTilMoete()!.gruppe.organisasjonsnavn} }}
          }
        </a>
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div>
        <button mat-raised-button color="primary" type="button" (click)="ferdig()" cdkFocusInitial data-testid="ferdig">
          {{ 'Lukk'|translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }
}
